import styled from 'styled-components';
import { NavTabTrigger, NavTabsList, TabsGroup } from 'ui/tabsGroup';
import { TAB_OPTIONS } from 'modules/segmentation/constants';
import { useGetTabOptions, useTranslation } from '../../hooks';

const StyledTabsGroup = styled(TabsGroup)`
  [role='tablist'] {
    border-bottom: none;
  }
`;

type TabsProps = {
  selectedTab: TAB_OPTIONS;
  onTabChange: (newTab: TAB_OPTIONS) => void;
};

export const Tabs = ({ selectedTab, onTabChange }: TabsProps) => {
  const { t } = useTranslation();
  const tabOptions = useGetTabOptions();
  return (
    <StyledTabsGroup
      value={selectedTab}
      onValueChange={(newTab) => onTabChange(newTab as TAB_OPTIONS)}
    >
      <NavTabsList>
        {tabOptions.map((tab: TAB_OPTIONS) => (
          <NavTabTrigger key={tab} value={tab}>
            {t(tab)}
          </NavTabTrigger>
        ))}
      </NavTabsList>
    </StyledTabsGroup>
  );
};
